import { getComponentClasses } from '@99designs/common/utils/app';
import React from 'react';

interface Props {
    attribution: string;
    variations?: string[];
    imageSource: string;
    imageAlt?: string;
    imageTitle?: string;
}

const DesignFigure: React.FunctionComponent<Props> = ({
    attribution,
    imageAlt,
    imageSource,
    imageTitle,
    variations,
}) => (
    <figure className={getComponentClasses('design-figure', variations)}>
        <div className="design-figure__image-container">
            <img
                className="design-figure__image-container__image"
                src={imageSource}
                alt={imageAlt}
                title={imageTitle}
            />
        </div>
        <figcaption className="design-figure__attribution">
            <span className="attribution attribution--small">{attribution}</span>
        </figcaption>
    </figure>
);

export default DesignFigure;
